import {IPhoneFieldValue} from "@pg-design/phone-input-module";

import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {isSmsLoginAccountMismatchError, usePostSmsLoginInitMutation} from "../api/sms_login";
import {HTTP_STATUS_TOO_MANY_REQUESTS} from "../constants/http_status_too_many_requests";
import {saveWizardDraft, setStep} from "../state/registration_flow_slice";
import {RegistrationFlowStep} from "../types/RegistrationFlowStep";
import {getSmsLoginPhoneString, isSamePhone} from "../utils/registration_wizard_phone";
import {getSmsCodeCooldownRemainingSeconds} from "../utils/registration_wizard_sms_cooldown";
import {sendRegistrationWizardSmsCode} from "../utils/send_registration_wizard_sms_code";

interface IUseRegistrationWizardSmsLoginCodeParams {
    setPhoneError: (message: string) => void;
    setIsSmsLimitReached: (isSmsLimitReached: boolean) => void;
    setIsAccountMismatch: (isAccountMismatch: boolean) => void;
}

/** SMS login path of the phone step: sends the login code, or reuses the one still in cooldown for the same phone */
export const useRegistrationWizardSmsLoginCode = (params: IUseRegistrationWizardSmsLoginCodeParams) => {
    const {setPhoneError, setIsSmsLimitReached, setIsAccountMismatch} = params;
    const dispatch = useAppDispatch();
    const {wizardDrafts} = useAppSelector((state) => state.registrationFlow);
    const [postSmsLoginInit] = usePostSmsLoginInitMutation();

    const sendSmsLoginCode = async (phone: IPhoneFieldValue) => {
        if (!wizardDrafts.email) {
            dispatch(setStep({step: RegistrationFlowStep.REGISTRATION}));
            return;
        }

        if (isSamePhone(phone, wizardDrafts.smsLoginPhone) && getSmsCodeCooldownRemainingSeconds("smsLogin") > 0) {
            dispatch(saveWizardDraft({phone}));
            dispatch(setStep({step: RegistrationFlowStep.PHONE_VERIFICATION}));
            return;
        }

        const {error: smsLoginError} = await sendRegistrationWizardSmsCode(
            postSmsLoginInit({email: wizardDrafts.email, phone: getSmsLoginPhoneString(phone)}),
            "smsLogin"
        );

        if (smsLoginError) {
            if (isSmsLoginAccountMismatchError(smsLoginError)) {
                setIsAccountMismatch(true);
                return;
            }

            setPhoneError(smsLoginError.message);
            setIsSmsLimitReached(smsLoginError.status === HTTP_STATUS_TOO_MANY_REQUESTS);
            return;
        }

        dispatch(saveWizardDraft({phone, smsLoginPhone: phone}));
        dispatch(setStep({step: RegistrationFlowStep.PHONE_VERIFICATION}));
    };

    return {sendSmsLoginCode};
};
import {IPhoneFieldValue} from "@pg-design/phone-input-module";

import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {isSmsLoginAccountMismatchError, usePostSmsLoginInitMutation} from "../api/sms_login";
import {HTTP_STATUS_TOO_MANY_REQUESTS} from "../constants/http_status_too_many_requests";
import {saveWizardDraft, setStep} from "../state/registration_flow_slice";
import {RegistrationFlowStep} from "../types/RegistrationFlowStep";
import {getSmsLoginPhoneString, isSamePhone} from "../utils/registration_wizard_phone";
import {getSmsCodeCooldownRemainingSeconds} from "../utils/registration_wizard_sms_cooldown";
import {sendRegistrationWizardSmsCode} from "../utils/send_registration_wizard_sms_code";

interface IUseRegistrationWizardSmsLoginCodeParams {
    setPhoneError: (message: string) => void;
    setIsSmsLimitReached: (isSmsLimitReached: boolean) => void;
    setIsAccountMismatch: (isAccountMismatch: boolean) => void;
}

/** SMS login path of the phone step: sends the login code, or reuses the one still in cooldown for the same phone */
export const useRegistrationWizardSmsLoginCode = (params: IUseRegistrationWizardSmsLoginCodeParams) => {
    const {setPhoneError, setIsSmsLimitReached, setIsAccountMismatch} = params;
    const dispatch = useAppDispatch();
    const {wizardDrafts} = useAppSelector((state) => state.registrationFlow);
    const [postSmsLoginInit] = usePostSmsLoginInitMutation();

    const sendSmsLoginCode = async (phone: IPhoneFieldValue) => {
        if (!wizardDrafts.email) {
            dispatch(setStep({step: RegistrationFlowStep.REGISTRATION}));
            return;
        }

        if (isSamePhone(phone, wizardDrafts.smsLoginPhone) && getSmsCodeCooldownRemainingSeconds("smsLogin") > 0) {
            dispatch(saveWizardDraft({phone}));
            dispatch(setStep({step: RegistrationFlowStep.PHONE_VERIFICATION}));
            return;
        }

        const {error: smsLoginError} = await sendRegistrationWizardSmsCode(
            postSmsLoginInit({email: wizardDrafts.email, phone: getSmsLoginPhoneString(phone)}),
            "smsLogin"
        );

        if (smsLoginError) {
            if (isSmsLoginAccountMismatchError(smsLoginError)) {
                setIsAccountMismatch(true);
                return;
            }

            setPhoneError(smsLoginError.message);
            setIsSmsLimitReached(smsLoginError.status === HTTP_STATUS_TOO_MANY_REQUESTS);
            return;
        }

        dispatch(saveWizardDraft({phone, smsLoginPhone: phone}));
        dispatch(setStep({step: RegistrationFlowStep.PHONE_VERIFICATION}));
    };

    return {sendSmsLoginCode};
};
